/**
 * This file was automatically generated by `bwcx-client-vue`.
 * DO NOT MODIFY IT BY HAND.
 */

import { parseRoutes, RenderMethodKind } from 'bwcx-client-vue3';
import { DemoDetailRPO } from '../../common/modules/demo/demo.rpo';

const clientRoutes = parseRoutes([
  {
    name: 'About',
    path: '/about',
    fullPath: '/about',
    component: () => import(/* webpackChunkName: "About" */ '../modules/about/about.view.vue'),
    routeProps: undefined,
    priority: undefined,
    renderMethod: undefined,
    otherOptions: undefined,
  },
  {
    name: 'AdminView',
    path: '/admin',
    fullPath: '/admin',
    component: () => import(/* webpackChunkName: "AdminView" */ '../modules/admin/admin.view.vue'),
    routeProps: undefined,
    priority: undefined,
    renderMethod: RenderMethodKind.CSR,
    children: [
      {
        name: 'GlobalConfigView',
        path: '/admin/global-config',
        fullPath: '/admin/global-config',
        component: () => import(/* webpackChunkName: "GlobalConfigView" */ '../modules/admin/global-config.view.vue'),
        routeProps: undefined,
        priority: undefined,
        renderMethod: RenderMethodKind.CSR,
        otherOptions: undefined,
      },
      {
        name: 'MediaListContainer',
        path: '/admin/media-list/:id',
        fullPath: '/admin/media-list/:id',
        component: () => import(/* webpackChunkName: "MediaListContainer" */ '../modules/admin/media-list-container.view.vue'),
        routeProps: undefined,
        priority: undefined,
        renderMethod: RenderMethodKind.CSR,
        otherOptions: undefined,
      },
      {
        name: 'NewsListContainer',
        path: '/admin/news-list',
        fullPath: '/admin/news-list',
        component: () => import(/* webpackChunkName: "NewsListContainer" */ '../modules/admin/news-list-container.view.vue'),
        routeProps: undefined,
        priority: undefined,
        renderMethod: RenderMethodKind.CSR,
        otherOptions: undefined,
      },
      {
        name: 'OverviewView',
        path: '/admin/overview',
        fullPath: '/admin/overview',
        component: () => import(/* webpackChunkName: "OverviewView" */ '../modules/admin/overview.view.vue'),
        routeProps: undefined,
        priority: undefined,
        renderMethod: RenderMethodKind.CSR,
        otherOptions: undefined,
      },
      {
        name: 'ProjectListContainer',
        path: '/admin/project-list',
        fullPath: '/admin/project-list',
        component: () => import(/* webpackChunkName: "ProjectListContainer" */ '../modules/admin/project-list-container.view.vue'),
        routeProps: undefined,
        priority: undefined,
        renderMethod: RenderMethodKind.CSR,
        otherOptions: undefined,
      },
      {
        name: 'UsersAdminView',
        path: '/admin/settings',
        fullPath: '/admin/settings',
        component: () => import(/* webpackChunkName: "UsersAdminView" */ '../modules/admin/users-admin.view.vue'),
        routeProps: undefined,
        priority: undefined,
        renderMethod: RenderMethodKind.CSR,
        otherOptions: undefined,
      },
    ],
    otherOptions: undefined,
  },
  {
    name: 'NewsPreviewView',
    path: '/admin/news-preview/:id',
    fullPath: '/admin/news-preview/:id',
    component: () => import(/* webpackChunkName: "NewsPreviewView" */ '../modules/admin/news-preview.view.vue'),
    routeProps: undefined,
    priority: undefined,
    renderMethod: RenderMethodKind.CSR,
    otherOptions: undefined,
  },
  {
    name: 'DemoDetail',
    path: '/demo/detail/:id',
    fullPath: '/demo/detail/:id',
    component: () => import(/* webpackChunkName: "DemoDetail" */ '../modules/demo/demo-detail.view.vue'),
    routeProps: DemoDetailRPO,
    priority: undefined,
    renderMethod: RenderMethodKind.SSR,
    otherOptions: undefined,
  },
  {
    name: 'HomeView',
    path: '/',
    fullPath: '/',
    component: () => import(/* webpackChunkName: "HomeView" */ '../modules/home/home.view.vue'),
    routeProps: undefined,
    priority: undefined,
    renderMethod: RenderMethodKind.SSR,
    otherOptions: undefined,
  },
  {
    name: 'LoginView',
    path: '/login',
    fullPath: '/login',
    component: () => import(/* webpackChunkName: "LoginView" */ '../modules/login/login.view.vue'),
    routeProps: undefined,
    priority: undefined,
    renderMethod: RenderMethodKind.CSR,
    otherOptions: undefined,
  },
  {
    name: 'NewsView',
    path: '/news',
    fullPath: '/news',
    component: () => import(/* webpackChunkName: "NewsView" */ '../modules/news/news.view.vue'),
    routeProps: undefined,
    priority: undefined,
    renderMethod: RenderMethodKind.SSR,
    children: [
      {
        name: 'NewsCategoryView',
        path: '/news/category/:id',
        fullPath: '/news/category/:id',
        component: () => import(/* webpackChunkName: "NewsCategoryView" */ '../modules/news/news-category.view.vue'),
        routeProps: undefined,
        priority: undefined,
        renderMethod: RenderMethodKind.SSR,
        otherOptions: undefined,
      },
      {
        name: 'NewsDetailView',
        path: '/news/:id',
        fullPath: '/news/:id',
        component: () => import(/* webpackChunkName: "NewsDetailView" */ '../modules/news/news-detail.view.vue'),
        routeProps: undefined,
        priority: undefined,
        renderMethod: RenderMethodKind.SSR,
        otherOptions: undefined,
      },
      {
        name: 'NewsListView',
        path: '/news/overview',
        fullPath: '/news/overview',
        component: () => import(/* webpackChunkName: "NewsListView" */ '../modules/news/news-list.view.vue'),
        routeProps: undefined,
        priority: undefined,
        renderMethod: RenderMethodKind.SSR,
        otherOptions: undefined,
      },
    ],
    otherOptions: undefined,
  },
]);

export default clientRoutes;

